/**
 * Brand-refresh grounds sampled from reference-imgs/. None of these exist in the
 * @fe-toolkit/web-components palette yet. Delete this file and switch to
 * theme.colors when the refresh tokens ship.
 *
 * Sampled from screenshots, not the real Figma fills — needs sign-off from someone
 * with a Figma dev seat (see FAAS-776) before these are treated as final. Also a
 * finding for the FAAS-759 write-up: the refresh palette isn't in
 * @fe-toolkit/design-system-styles-js at all.
 */
export const BRAND = {
  pageGround: '#FAF9F5',
  promoGreen: '#76EC6E',
  phonesBand: '#E9E6E2',
  phoneCell: '#F4F2F0',
  appCream: '#F2F1E8',
  legalGround: '#F4F3EF',
} as const
